import {Component, ElementRef, ViewChild} from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {ActivatedRoute} from "@angular/router";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {TranslateService} from "../../translate";
import {MailService} from "../mail.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AuthService} from "../../auth.service";


import dictionaries from "dict/static.json";
import { MailTabGroup } from "app/models/mail";
import { FilterParams } from "../../models/filter_form.model";
import { IDataRequestResult } from "../../models/responce_result.model";

interface ISendTestMailResult extends IDataRequestResult {
	error: string;
}

@Component({
	selector: 'app-send-test',
	templateUrl: './send_test.component.html'
})
export class SendTestComponent extends BaseComponent {
	lng: string = 'ru';

	@ViewChild('modalProgress', {static: false})
	modalProgress: ElementRef;

	inProgress: boolean = false;
	resultMessage: string = '';

	mailTabGroups: MailTabGroup[] = [];
	
	constructor(
		public eventsService: EventsService,
		public service: MailService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService,
		public modalService: NgbModal,
		public authService: AuthService,
		public mailService: MailService,
	) {
		super(eventsService, service, activatedRoute, filter, translate);
		
		this.mailTabGroups = dictionaries.mailGroups;
	}

	async sendTest(action) {
		const me = this;

		me.inProgress = true;
		me.modalService.open(me.modalProgress);
		
		try {
			const result = await me.mailService.testMail.post<ISendTestMailResult>(<FilterParams>{
				lng: me.lng,
				action: action,
				email: this.authService.email,
				firstName: this.authService.firstName || 'Какое-то firstName',
				lastName: this.authService.lastName || 'Какое-то lastName',
				comment: 'Отправка письма из отчёта "Тестирование"',
			}).toPromise();
			
			me.resultMessage = result.error ? `Ошибка: ${result.error}` : 'Письмо успешно отправлено';
		} catch (err) {
			me.resultMessage = `Ошибка: ${err}`;
		}

		this.inProgress = false;
	}
}
